import { Dropdown } from "./bootstrap.js";

document.addEventListener("DOMContentLoaded", () => {
  let isKeyboardUser = false;

  document.body.addEventListener(
    "keydown",
    (e) => {
      if (
        [
          "Tab",
          "ArrowUp",
          "ArrowDown",
          "ArrowLeft",
          "ArrowRight",
          "Enter",
          " ",
        ].includes(e.key)
      ) {
        isKeyboardUser = true;
      }
    },
    true
  );

  document.body.addEventListener(
    "mousedown",
    () => {
      isKeyboardUser = false;
    },
    true
  );

  const dropdownToggles = document.querySelectorAll(
    ".navbar-nav .menu-item.dropdown"
  );

  if (!dropdownToggles.length) {
    return;
  }

  dropdownToggles.forEach((listItem) => {
    const toggleElement = listItem.querySelector('[data-bs-toggle="dropdown"]');
    const menuElement = listItem.querySelector(".dropdown-menu");

    if (!toggleElement || !menuElement) {
      return;
    }

    const allFocusableElements = [
      toggleElement,
      ...menuElement.querySelectorAll(".dropdown-item"),
    ];
    const dropdownInstance = Dropdown.getOrCreateInstance(toggleElement);

    allFocusableElements.forEach((el) => {
      if (!el) return;

      el.addEventListener("focus", () => {
        if (isKeyboardUser) {
          el.classList.add("keyboard-focus");
        } else {
          el.classList.remove("keyboard-focus");
        }
      });

      el.addEventListener("blur", () => {
        el.classList.remove("keyboard-focus");
      });
    });

    listItem.addEventListener("mouseenter", () => {
      if (!listItem.classList.contains("show")) {
        dropdownInstance.show();
      }
      if (toggleElement) toggleElement.classList.remove("keyboard-focus");
    });

    // --- MODIFIED PART ---
    // Always hide the dropdown when the mouse leaves the list item
    listItem.addEventListener("mouseleave", () => {
      dropdownInstance.hide();
    });
    // --- END MODIFIED PART ---

    toggleElement.addEventListener("focus", () => {
      dropdownInstance.show();
      if (isKeyboardUser) {
        toggleElement.classList.add("keyboard-focus");
      }
    });

    listItem.addEventListener("focusout", (event) => {
      setTimeout(() => {
        // Hide only if focus moved completely outside the list item
        if (!listItem.contains(document.activeElement)) {
          dropdownInstance.hide();
        }
      }, 0);
    });
  });
});
